import React from 'react';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import { CampaignBoost, Close, RakutenClubLogo, RightRedArrow } from '@rakutenfrance/shared-svg';
import { colorPalette } from '../../colorPalette';
import { Typography } from '../Typography';
import { CurrencyFormatter } from '../CurrencyFormatter';
import { Button } from '../Button';
import { ClubPopinStyle } from './ClubPopin.style';
export const ClubPopIn = ({ isClubMember, amount, type, hasMerchantCampaign, sellerName, crossedAmount, isOpenClubPopIn, setIsOpenClubPopIn, }) => {
    return (React.createElement(Modal, { open: isOpenClubPopIn, sx: ClubPopinStyle.modal, onClose: () => {
            setIsOpenClubPopIn(false);
        }, slotProps: {}, disableAutoFocus: true },
        React.createElement(Stack, { alignItems: "center", justifyContent: "center", sx: ClubPopinStyle.container },
            React.createElement(Stack, { width: "100%", alignItems: "flex-end" },
                React.createElement(Stack, { component: "div", flexDirection: "row", sx: ClubPopinStyle.closeButton, onClick: () => {
                        setIsOpenClubPopIn(false);
                    } },
                    React.createElement(Close, { width: "24" }))),
            React.createElement(Stack, { sx: {
                    marginTop: '8px',
                    marginBottom: '32px',
                } },
                React.createElement(RakutenClubLogo, { width: "100", height: "37" })),
            React.createElement(Typography, { variant: "h1-semibold", color: colorPalette.gray800 }, "Votre fid\u00E9lit\u00E9 r\u00E9compens\u00E9e"),
            React.createElement(Typography, { component: "p", variant: "body-default-regular", color: colorPalette.gray500, sx: {
                    margin: '8px 32px 0',
                    textAlign: 'center',
                } }, "Gagnez du cashback \u00E0 chacun de vos achats sur Rakuten et ses partenaires."),
            React.createElement(Stack, { sx: ClubPopinStyle.label },
                React.createElement(Typography, { variant: "body-small-semibold", color: colorPalette.red800 }, "GRATUIT & SANS ENGAGEMENT")),
            hasMerchantCampaign && sellerName && (React.createElement(Stack, { alignItems: "center", flexDirection: "row", sx: ClubPopinStyle.campaignContainer },
                React.createElement(Stack, { sx: ClubPopinStyle.campaignIconBox },
                    React.createElement(CampaignBoost, null)),
                React.createElement(Stack, { sx: {
                        marginRight: '8px',
                    } },
                    React.createElement(Typography, { component: "p", variant: "body-default-semibold", color: colorPalette.gray900 },
                        sellerName,
                        " est g\u00E9n\u00E9reux !"),
                    React.createElement(Typography, { component: "p", color: colorPalette.gray800, variant: "body-default-regular" },
                        "Ce vendeur vous permet de multiplier vos gains\u00A0",
                        React.createElement(Typography, { component: "span", variant: "body-default-regular", color: colorPalette.red800 }, "aujourd\u2019hui seulement !"))))),
            (amount !== null && amount !== void 0 ? amount : 0) > 0 ? (React.createElement(Stack, { flexDirection: "row", width: "100%" },
                React.createElement(Stack, { width: "100%", justifyContent: "center", alignItems: "center", sx: {
                        padding: '26px 0',
                        border: `1px solid ${colorPalette.gray300}`,
                    } },
                    React.createElement(Typography, { component: "p", variant: "body-small-semibold", color: colorPalette.gray700, textTransform: "uppercase", letterSpacing: 1.5, lineHeight: 19 }, "SUR CE PRODUIT"),
                    hasMerchantCampaign && (crossedAmount !== null && crossedAmount !== void 0 ? crossedAmount : 0) > 0 && (React.createElement(Typography, { component: "p", variant: "body-default-regular", color: colorPalette.gray500, sx: {
                            textDecoration: 'line-through',
                        } },
                        React.createElement(CurrencyFormatter, { amount: crossedAmount, withCurrencySymbol: type === 'e' ? true : false }),
                        type === 'e' ? '' : '%')),
                    React.createElement(Typography, { component: "p", variant: "h1-semibold", color: colorPalette.red800, sx: {
                            margin: '12px 0',
                        } },
                        React.createElement(CurrencyFormatter, { amount: amount, withCurrencySymbol: type === 'e' ? true : false }),
                        React.createElement(Typography, { variant: "h2-semibold", component: "span", sx: {
                                position: 'relative',
                                top: '-10',
                            } }, type === 'e' ? '' : '%'))),
                React.createElement(Stack, { justifyContent: "center", sx: {
                        border: `1px solid ${colorPalette.gray300}`,
                        padding: '26px 0',
                        width: '100%',
                    } },
                    React.createElement(Stack, { flexDirection: "row", alignItems: "baseline", sx: {
                            margin: '4px 16px',
                        } },
                        React.createElement(RightRedArrow, null),
                        React.createElement(Typography, { component: "span", variant: "body-default-regular", color: colorPalette.gray700, lineHeight: "145.5%", sx: {
                                marginLeft: '8px',
                            } }, "Cr\u00E9dit\u00E9s sur votre cagnotte")),
                    React.createElement(Stack, { flexDirection: "row", alignItems: "baseline", sx: {
                            margin: '4px 16px',
                        } },
                        React.createElement(RightRedArrow, null),
                        React.createElement(Typography, { component: "span", variant: "body-default-regular", color: colorPalette.gray700, lineHeight: "145.5%", sx: {
                                marginLeft: '8px',
                            } }, "A d\u00E9penser sur vos prochains achats"))))) : (React.createElement(Stack, { justifyContent: "center", sx: ClubPopinStyle.cashbackContainer },
                React.createElement(Stack, { flexDirection: "row", alignItems: "baseline", sx: {
                        margin: '4px 16px',
                    } },
                    React.createElement(Stack, null,
                        React.createElement(RightRedArrow, null)),
                    React.createElement(Typography, { component: "span", variant: "body-default-regular", color: colorPalette.gray700, lineHeight: "145.5%", sx: {
                            marginLeft: '8px',
                        } }, "Le club le plus g\u00E9n\u00E9reux de France")),
                React.createElement(Stack, { flexDirection: "row", alignItems: "baseline", sx: {
                        margin: '4px 16px',
                    } },
                    React.createElement(Stack, null,
                        React.createElement(RightRedArrow, null)),
                    React.createElement(Typography, { component: "span", variant: "body-default-regular", color: colorPalette.gray700, lineHeight: "145.5%", sx: {
                            marginLeft: '8px',
                        } }, "Jusqu\u2019\u00E0 40% rembours\u00E9s en cashback sur des milliers d\u2019articles")))),
            !isClubMember && (React.createElement(Stack, { sx: {
                    width: '100%',
                    backgroundColor: colorPalette.white,
                    padding: '16px 16px 0',
                } },
                React.createElement(Button, { color: "primary", sx: {
                        height: '50px',
                    }, variant: "contained", onClick: () => {
                        // getXiti(MODULE_NAME)?.clickTag(
                        //   getXiti(MODULE_NAME)?.level2?.FPDA,
                        //   "ClickPopinDevenirMembre",
                        //   getXiti(MODULE_NAME)?.types?.NAVIGATION
                        // );
                        const redirectUrlObj = new URL(window.location.href);
                        window.location.href = '/register?redirect_url=' + encodeURIComponent(redirectUrlObj.pathname + redirectUrlObj.search);
                    } },
                    React.createElement(Typography, { variant: "body-default-regular" }, "Devenir membre")))))));
};
